import file from './modules/file';
import fast from './modules/fast';

const man = {
    file,
    fast,
};

export default man;